export const TICKETS_PATHS = {
  ticketLink: 'ticket',
  ticket: 'ticket/:ticket_id',
};
